export default __webpack_public_path__ + "static/media/project3.96ab7f5c.jpeg";